import React, { useEffect, useState } from "react";
import '../../../CSS/TablaHerramientas.css'
import {BsPlus} from "react-icons/bs";
import {getPermission} from '../../../Conexiones/Conexion'
import { useNavigate } from "react-router";
import { BsTrash } from "react-icons/bs";
import { FaArrowLeftLong } from "react-icons/fa6";
import { deleteApi, getApi, postApi } from "../../../Conexiones/Models";
import { errorMessage, errorToast, successToast, warningModal, warningToast } from "../../../Utils/AlertMessage";
import Loading from '../../../Utils/Loading';
import { Button, CloseButton, Modal } from "react-bootstrap";
import { SlLogin, SlLogout } from "react-icons/sl";
import Select from "react-select";

function ManoObra(){
    const navigate = useNavigate();
    const obraId = parseInt(sessionStorage.getItem("obra"));
    const [manoObra, setManoObra] = useState([]);
    const [tablaPer, setTablaPer] = useState([]);
    const [residente, setResidente] = useState({});
    const [busqueda, setBusqueda] = useState("");
    const [obra,setObra] = useState('');
    const usuario = JSON.parse(sessionStorage.getItem('user'));
    const idUsuario = usuario[0].idUsuario;
    const [isSaving, setSaving] = useState(false);
    const [isLoading,setIsLoading]=useState(false);

    useEffect( ()=>{
        const getManoObra = async () =>{
            setIsLoading(true);
            const permiso = await getPermission(idUsuario,22);
            if(permiso){
                const endpoint = 'mano-obra-ini/'+obraId;
                const res = await getApi(endpoint);
                if(res.status === 1){
                    if(res.data.length !== undefined){
                        setManoObra(res.data[0].manoObra);
                        setTablaPer(res.data[0].manoObra);
                        setResidente(res.data[0].residente);
                        setObra(res.data[0].obra);
                    }else{
                        errorMessage(res.data.message);
                    }
                }else if(res.status === 210){
                    navigate('/');
                }else{
                    errorMessage(res.message);
                }
            }else{
                navigate('/inicio');
            }
            setIsLoading(false);
        }
        getManoObra();
    },[idUsuario,navigate,obraId])

    const getManoObra = async () =>{
        const endpoint = 'mano-obra-ini/'+obraId;
        const res = await getApi(endpoint);
        if(res.status === 1){
            if(res.data.length !== undefined){
                setManoObra(res.data[0].manoObra);
                setTablaPer(res.data[0].manoObra);
            }else{
                errorMessage(res.data.message);
            }
        }else if(res.status === 210){
            navigate('/');
        }else{
            errorMessage(res.message);
        }
    }

    const buscar = e => {
        setBusqueda(e.target.value);
        filtrar(e.target.value);
    }

    const filtrar = (texto) => {
        var resBusqueda = tablaPer.filter((elemento)=> {
            if(elemento.nombreEmp.toString().toLowerCase().includes(texto.toLowerCase())){  
                return elemento;
            }
            return resBusqueda;
        });
        setManoObra(resBusqueda);
    }
    const regresar = () => {
        navigate('/inicio/Proyectos/Lista-Obras/Administracion-Obras');
    }

    const modalDelete = (ide,ido) => {
        warningModal('¿QUIERES ELIMINAR ESTE EMPLEADO?')
        .then(async (result) => {
            if (result.isConfirmed) {
                const endpoint = 'mano-obra/' + ido + '/emp/' + ide;
                const res = await deleteApi(endpoint);
                if(res.status === 1){
                    if(res.data.message==="¡EMPLEADO ELIMINADO CORRECTAMENTE!"){
                        getManoObra();
                        successToast("ELIMINADO");
                    }else{
                        errorToast("¡ERROR!",res.data.message);
                    }
                }else if(res.status === 210){
                    navigate('/');
                }else{
                    errorMessage(res.message);
                }
            }
        })
    }

    /*AGREGAR MANO OBRA INICIO*/
    const [lista, setLista] = useState([]);
    const [personal, setPersonal] = useState([]);
    const [tablaEmp, setTablaEmp] = useState([]);
    const [busquedaM, setBusquedaM] = useState("");
    const [showAdd, setShowAdd] = useState(false);
    const handleCloseAdd = () => {
        setShowAdd(false);
        setLista([]);
    }
    const handleShowAdd = async () =>{
        await getPersonal();
        setShowAdd(true);
    }
    const getPersonal = async () =>{
        const endpoint = 'getmano-obra/'+obraId;
        const res = await getApi(endpoint);
        if(res.status === 1){
            if(res.data.length !== undefined){
                setPersonal(res.data);
                setTablaEmp(res.data);
            }else{
                errorMessage(res.data.message);
            }
        }else if(res.status === 210){
            navigate('/');
        }else{
            errorMessage(res.message);
        }
    }
    const buscarM = e => {
        setBusquedaM(e.target.value)
        filtrarM(e.target.value)
    }
    const filtrarM = (texto) => {
        var resBusqueda = tablaEmp.filter((elemento)=> {
            if  (elemento.nombreEmp.toString().toLowerCase().includes(texto.toLowerCase())){  
                return elemento; }
                return resBusqueda
            })
        setPersonal(resBusqueda)
    }
    const addPer = async (idE, nomE, apE, amE, npE) =>{
        const newPersonal = personal.filter((item) => item.idEmpleado !== idE) ;        
        setPersonal(newPersonal)
        const tabla = tablaEmp.filter((item) => item.idEmpleado !== idE) ;
        setTablaEmp(tabla)
        const newPerson = {idP: idE, nomP: nomE,
        apP: apE, amP: amE, npP: npE
        }
        setLista([...lista, newPerson]) 
    }
    
    const deletPerson = async(id, nom, apep, apem, nomP) => {
        const newPersonal = lista.filter((item) => item.idP !== id) ;
        setLista(newPersonal)
        const newPerson = {idEmpleado: id, nombreEmp: nom, apellidoPaternoEmp: apep, 
        apellidoMaternoEmp: apem, nombrePuesto: nomP
        }
        setPersonal([...personal, newPerson])
        const person = {idEmpleado: id, nombreEmp: nom, apellidoPaternoEmp: apep, 
        apellidoMaternoEmp: apem, nombrePuesto: nomP
        }
        setTablaEmp([...tablaEmp, person])
    }
    
    const cancelar = async () => {
        if(lista.length === 0 ){
            handleCloseAdd();
        }else{
            warningToast('¿SEGURO QUE QUIERES SALIR?','UNA VEZ CANCELADO SE ELIMINARAN LOS CAMBIOS',true)
            .then((result) => {
                if (result.isConfirmed) {
                    handleCloseAdd();
                }
            });
        } 
    }
    const store = async () =>{
        setSaving(true);
        if(lista.length === 0){
            warningToast('Ningún empleado seleccionado');
        }else{
            const listaPersonal = JSON.stringify(lista);
            const endpoint = 'mano-obra/';
            const data = {lista:listaPersonal,idObra:obraId,};
            const res = await postApi(endpoint,data);
            if(res.status === 1){
                if(res.data.message==="¡PERSONAL AGREGADO CORRECTAMENTE!"){
                    handleCloseAdd();
                    getManoObra();
                    successToast("AGREGADO");
                }else{
                    errorToast("¡ERROR!",res.data.message);
                }
            }else if(res.status === 210){
                navigate('/');
            }else{
                errorMessage(res.message);
            }
        }
        setSaving(false);
    }
    /*AGREGAR MANO OBRA FIN*/

    /*AGREGAR RESIDENTE INICIO*/
    const [idResidente, setIdResidente] = useState('');
    const [residentes, setResidentes] = useState([]);
    const [showAR, setShowAR] = useState(false);
    const handleCloseAR = () => {
        setShowAR(false);
        setIdResidente('');
    }
    const handleShowAR = async () =>{
        await getResidentes();
        setShowAR(true);
    }
    const getResidentes = async () =>{
        const endpoint = 'residentes/';
        const res = await getApi(endpoint);
        if(res.status === 1){
            if(res.data.length !== undefined){
                setResidentes(res.data);
            }else{
                errorMessage(res.data.message);
            }
        }else if(res.status === 210){
            navigate('/');
        }else{
            errorMessage(res.message);
        }
    }
    const getResidente = async () =>{
        const endpoint = 'residentes/'+obraId;
        const res = await getApi(endpoint);
        if(res.status === 1){
            if(res.data.length !== undefined){
                setResidente(res.data[0]);
            }else{
                errorMessage(res.data.message);
            }
        }else if(res.status === 210){
            navigate('/');
        }else{
            errorMessage(res.message);
        }
    }
    const handleSelectChange = (event) =>{
        setIdResidente(event.value)
    }
    const storeResident = async () =>{
        setSaving(true);
        if(idResidente === ''){
            warningToast('Seleccione un empleado');
        }else{
            const endpoint = 'residentes/';
            const data = {idObra:obraId, idResidente:idResidente};
            const res = await postApi(endpoint,data);
            if(res.status === 1){
                if(res.data.message==="¡RESIDENTE AGREGADO!"){
                    handleCloseAR();
                    getResidente();
                    successToast("AGREGADO");
                }else{
                    errorToast("¡ERROR!",res.data.message);
                }
            }else if(res.status === 210){
                navigate('/');
            }else{
                errorMessage(res.message);
            }
        }
        setSaving(false);
    }
    /*AGREGAR RESIDENTE FIN*/

    /*EDITAR RESIDENTE INICIO*/
    const [showUR, setShowUR] = useState(false);
    const handleCloseUR = () => {
        setShowUR(false);
        setIdResidente('');
    }
    const handleShowUR = async () =>{
        await getResidentes();
        setShowUR(true);
    }
    const updateResident= async () => {
        setSaving(true);
        if(idResidente === ''){
            warningToast('Seleccione un empleado');
        }else{
            const endpoint = 'residentes/';
            const data = {idObra:obraId, idResidente:idResidente};
            const res = await postApi(endpoint,data);
            if(res.status === 1){
                if(res.data.message==="¡RESIDENTE AGREGADO!"){
                    handleCloseUR();
                    getResidente();
                    successToast("AGREGADO");
                }else{
                    errorToast("¡ERROR!",res.data.message);
                }
            }else if(res.status === 210){
                navigate('/');
            }else{
                errorMessage(res.message);
            }
        }
        setSaving(false);
    }
    /*EDITAR RESIDENTE FIN*/
    
    return(
        <div className="tablaHerramientas">
            {
                isLoading === true ? 
                <Loading />:
                <div>
                    <div className='contabilidades-header'>
                        <div className='fab'><FaArrowLeftLong className='arrow' onClick={regresar} title='REGRESAR'/></div>
                        <label className="text-uppercase">MANO DE OBRA</label>
                    </div>
                    <div>
                        <h4 className='text-uppercase'>{obra}</h4>
                    </div>
                    { residente === null ? (
                        <div className="divboton" style={{textAlign:'left'}}>
                            <button  className="btn btncolor" onClick={handleShowAR} style={{marginLeft:'10px'}}>
                                <label className="agregar">RESIDENTE</label><BsPlus style={{fontSize:'25px'}}/>
                            </button>
                        </div>
                    ):(
                        <div style={{textAlign:'left'}}>
                            <div key={residente.idResidente}>
                                <label style={{marginLeft:'10px'}} className="form-label text-uppercase">RESIDENTE: <strong> {residente.residente}</strong></label> &nbsp;
                                <span className="bi bi-pen" style={{color:'#dfab00', fontSize:'18px', cursor:'pointer'}} title="MODIFICAR" onClick={handleShowUR}></span>
                            </div>
                        </div>
                        )
                    }
                    <div className='divboton' >                                                                                             
                        <div className='boton' style={{display:'flex', justifyContent:'space-between'}} >
                            <button  className="btn btncolor" onClick={handleShowAdd}>
                                <label className="agregar">PERSONAL</label><BsPlus style={{fontSize:'25px'}}/>
                            </button>
                            <input className="form-control" value={busqueda} onChange={buscar} style={{width:'50%'}} type="search" placeholder="Buscar" aria-label="Search"/>
                        </div>
                    </div>
                    {
                        manoObra.length === 0 ? (<h3 style={{marginTop:'30vh'}}>AUN NO HAY REGISTROS</h3>):(
                            <div className="tabla-cajaH" >
                                <div className="table tabla">
                                    <table className="table table-hover table-bordered text-uppercase">
                                        <thead className="encabezado">
                                            <tr >                                
                                                <th>EMPLEADO</th>
                                                <th>PUESTO</th>
                                                <th>ELIMINAR</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {manoObra.map(m =>{
                                                return(
                                                    <tr key={m.idEmpleado}>
                                                        <td>{m.nombreEmp}{' '}{m.apellidoPaternoEmp}{' '}{m.apellidoMaternoEmp}</td>
                                                        <td>{m.nombrePuesto}</td>       
                                                        <td>
                                                            <BsTrash title="ELIMINAR PERSONAL" style={{cursor:'pointer'}} onClick={() => modalDelete(m.idEmpleado,m.idObra)} />
                                                        </td>
                                                    </tr>                                   
                                                )
                                            })}                        
                                        </tbody>
                                    </table>
                                </div>           
                            </div>
                        )
                    }
                </div>
            }

            {/*AGREGAR PERSONAL*/}     
            <Modal show={showAdd}  onHide={handleCloseAdd} fullscreen={true} id="modal-agregar-personal" backdrop="static" keyboard={false}>
                <Modal.Header className=' btncolor' style={{textAlign:"center"}}>
                    <Modal.Title>AGREGAR MANO DE OBRA</Modal.Title>
                    <CloseButton onClick={cancelar} style={{backgroundColor:"white"}} />
                </Modal.Header>
                <Modal.Body  style={{textAlign:'left',height:'60vh', overflowY:"scroll" }}>
                    <div style={{width:'100%'}}>
                        <div className="lista">
                            <div style={{textAlign:"center"}}><h5 className="text-uppercase">{`LISTA DE EMPLEADOS ${obra}`}</h5></div>
                            <div className="mb-3">
                                <input className="form-control" value={busquedaM} onChange={buscarM} style={{width:'90%'}} type="search" placeholder="Buscar" aria-label="Search"/>
                            </div>
                            <div className="table-responsive" style={{textAlign:'center', marginTop:'20px'}}>
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th>EMPLEADO</th>
                                            <th>PUESTO</th>
                                            <th><SlLogin title="AGREGAR EMPLEADO" /></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {personal.map(p =>{
                                            return(
                                                <tr key={p.idEmpleado} className="text-uppercase">
                                                    <td>{p.nombreEmp}{' '}{p.apellidoPaternoEmp}{' '}{p.apellidoMaternoEmp}</td>
                                                    <td>{p.nombrePuesto}</td>
                                                    <td>
                                                        <button className='btn btncolor' title="AGREGAR EMPLEADO"
                                                            onClick={()=>addPer(
                                                                p.idEmpleado, p.nombreEmp, p.apellidoPaternoEmp, 
                                                                p.apellidoMaternoEmp, p.nombrePuesto
                                                            )}>
                                                            +
                                                        </button>
                                                    </td>
                                                </tr>       
                                            )
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="lista">
                            <div style={{textAlign:"center"}}><h5>AGREGADOS</h5></div>
                            <div className="table-responsive" style={{backgroundColor:'#efefef', borderRadius:'10px'}}>
                                {lista.length === 0  ?(<div style={{height:'30vh', justifyContent:"center",alignItems:"center",display:"flex"}}><p>VACIO</p></div>):(
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th >NOMBRE</th>
                                            <th >PUESTO</th>
                                            <th><SlLogout/></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                    {
                                        lista.map(l=>{
                                            return(
                                                <tr key={l.idP} className="text-uppercase">
                                                    <td >{l.nomP}{' '}{l.apP}{' '}{l.amP}</td>
                                                    <td>{l.npP}</td>
                                                    <td>
                                                        <span className="bi bi-trash" style={{color:'red', cursor:'pointer'}} title="ELIMINAR" 
                                                            onClick={()=>deletPerson(
                                                                l.idP, l.nomP, l.apP, 
                                                                l.amP, l.npP
                                                            )} >
                                                        </span>
                                                    </td>
                                                </tr>
                                            )
                                        })
                                    }
                                    </tbody>
                                </table>
                                )}
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button type="button" className="btn btn-secondary"  onClick={cancelar} >CANCELAR</Button>
                    {
                        isSaving===true?
                        <Button className="btn btn-primary" type="button" disabled >
                            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            Loading...
                        </Button>:
                        <Button type="button" className="btn btn-light btncolor" onClick={store} >ACEPTAR</Button>
                    }
                </Modal.Footer>
            </Modal>

            {/*AGREGAR RESIDENTE*/}     
            <Modal show={showAR}  onHide={handleCloseAR} id="modal-agregar-residente" backdrop="static" keyboard={false}>
                <Modal.Header className=' btncolor' style={{textAlign:"center"}}>
                    <Modal.Title>AGREGAR RESIDENTE</Modal.Title>
                    <CloseButton onClick={handleCloseAR} style={{backgroundColor:"white"}} />
                </Modal.Header>
                <Modal.Body  style={{textAlign:'left', }}>
                    <div className="divO">
                        <label className="obligatorio">Obligatorio *</label>  
                    </div>
                    <div className="mb-3">
                        <label className="form-label">RESIDENTE<label title="OBLIGATORIO" className="obligatorio">*</label></label>
                        <Select 
                            classNamePrefix="select"
                            placeholder="Selecciona una opción"
                            name="residente"
                            options={residentes.map(r =>({
                                label: r.nombreEmp + ' ' + r.apellidoPaternoEmp  + ' ' + r.apellidoMaternoEmp, 
                                value: r.idEmpleado
                            }))}
                            onChange={handleSelectChange}
                        />
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button type="button" className="btn btn-secondary"  onClick={handleCloseAR} >CANCELAR</Button>
                    {
                        isSaving===true?
                        <Button className="btn btn-primary" type="button" disabled >
                            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            Loading...
                        </Button>:
                        <Button type="button" className="btn btn-light btncolor" onClick={storeResident} >ACEPTAR</Button>
                    }
                </Modal.Footer>
            </Modal>

            {/*EDITAR RESIDENTE*/}     
            <Modal show={showUR}  onHide={handleCloseUR} id="modal-editar-residente" backdrop="static" keyboard={false}>
                <Modal.Header className=' btncolor' style={{textAlign:"center"}}>
                    <Modal.Title>EDITAR RESIDENTE</Modal.Title>
                    <CloseButton onClick={handleCloseUR} style={{backgroundColor:"white"}} />
                </Modal.Header>
                <Modal.Body  style={{textAlign:'left', }}>
                    <div className="divO">
                        <label className="obligatorio">Obligatorio *</label>  
                    </div>
                    <div className="mb-3">
                        <label className="form-label">RESIDENTE<label title="OBLIGATORIO" className="obligatorio">*</label></label>
                        <Select 
                            defaultValue={residente === null ? null : { label: residente.residente, value: residente.idResidente }}
                            placeholder="Selecciona una opción"
                            name="residente"
                            options={residentes.map(r =>({
                                label: r.nombreEmp + ' ' + r.apellidoPaternoEmp  + ' ' + r.apellidoMaternoEmp, 
                                value: r.idEmpleado
                            }))}
                            onChange={handleSelectChange}
                        />
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button type="button" className="btn btn-secondary"  onClick={handleCloseUR} >CANCELAR</Button>
                    {
                        isSaving===true?
                        <Button className="btn btn-primary" type="button" disabled >
                            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            Loading...
                        </Button>:
                        <Button type="button" className="btn btn-light btncolor" onClick={updateResident} >ACEPTAR</Button>
                    }
                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default ManoObra;